const translations = {
  "en": {
    "Ed already is.": "Ed already is.",
    "Flag risks before they hit": "Flag risks before they hit",
    "Full read on all stocks": "Full read on all stocks",
    "New Signals Found by Ed": "New Signals Found by Ed",
    "Recharge Ed": "Recharge Ed",
    "Someone should always be watching the market for you": "Someone should always be watching the market for you",
    "Track your holdings while you're away": "Track your holdings while you're away",
    "Uh oh! You've reached your limit.": "Uh oh! You've reached your limit."
  },
  "zh-tw": {
    "Ed already is.": "Ed 已經是了。",
    "Flag risks before they hit": "在風險發生前預先警示",
    "Full read on all stocks": "完整解讀所有股票",
    "New Signals Found by Ed": "Ed 發現的新訊號",
    "Recharge Ed": "為 Ed 充電",
    "Someone should always be watching the market for you": "應該一直有人為你盯著市場。",
    "Track your holdings while you're away": "在你離開時追蹤你的持倉",
    "Uh oh! You've reached your limit.": "糟糕！你已達到上限。"
  }
};

export default translations;
